import { withOnLinkClickTracking } from 'auto-tracking';
import Link from 'next/link';

export const NextLink = withOnLinkClickTracking(Link);
